import React, {useEffect, useState} from 'react';
import {
   View,
   Text,
   Dimensions,
   StyleSheet,
   TouchableOpacity,
   Modal,
   Platform,
   Image,
} from 'react-native';
import {
   getAllSmallAlphabets,
   FONT_FAMILY_REGULAR,
   parseSpecialChar,
   WHITE_TEXT_HOVER_COLOR,
   aslCloseHandler,
} from '../../utils/utils';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useDispatch, useSelector} from 'react-redux';
import Asl from '../../components/asl';
import {isAndroid, isIOS} from 'react-device-detect';

const ReviewQuestionListItem = props => {
   const dispatch = useDispatch();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const {answerData, onRetryPressed, index} = props;
   const [answerHeaderTexts, setAnswerHeaderTexts] = useState([]);
   const [answerTexts, setAnswerTexts] = useState([]);
   const [isSelectedAnswer, setSelectedAnswer] = useState(false);
   const [isCorrectAnswer, setCorrectAnswer] = useState(false);
   const [isHover, setHover] = useState(false);
   useEffect(() => {
      splitAnswerTexts();
      if (onRetryPressed) {
         setSelectedAnswer(false);
      }
   });
   function splitAnswerTexts() {
      if (
         answerData.Answer.includes(')') &&
         answerData.Answer.split(')')[0].length === 1
      ) {
         setAnswerHeaderTexts(answerData.Answer.split(')')[0]);
         const indexOfColosingChar = answerData.Answer.indexOf(')') + 1;
         setAnswerTexts(
            parseSpecialChar(answerData.Answer.substring(indexOfColosingChar)),
         );
      } else {
         const headerText = getAllSmallAlphabets(index);
         setAnswerHeaderTexts(headerText);
         setAnswerTexts(parseSpecialChar(answerData.Answer));
      }
   }

   return (
      <TouchableOpacity
         onMouseEnter={() => setHover(true)}
         onMouseLeave={() => setHover(false)}
         style={{flex: 1}}
         onPress={() => {
            if (answerData?.TestItemAnswerMediaRelativePath) {
               aslCloseHandler(dispatch);
            }
            if (isSelectedAnswer) {
               setSelectedAnswer(false);
            } else {
               setSelectedAnswer(true);
            }
            if (answerData.CorrectAnswer == 'true') {
               setCorrectAnswer(true);
            } else {
               setCorrectAnswer(false);
            }
            props.onItemClick(answerData);
         }}>
         <View
            style={{
               // width:
               //   Platform.OS == 'android'
               //     ? Dimensions.get('screen').width / 2 - 40
               //     : Dimensions.get('screen').width / 2 - 60,

               flex: 1,
               marginTop: isLandscapeMode ? 16 : 8,
               flexDirection: 'row',
               borderRadius: 8,
               marginLeft: isLandscapeMode ? 25 : 16,
               marginRight: isLandscapeMode ? 25 : 16,
               minHeight: isLandscapeMode ? 64 : 48,
               backgroundColor: isSelectedAnswer
                  ? isCorrectAnswer
                     ? '#8FE7B8'
                     : '#FFDCDA'
                  : '#454545',
            }}>
            <View
               style={[
                  styles.answerHeaderContainer,
                  {
                     width: isLandscapeMode ? 64 : 48,
                     backgroundColor: isSelectedAnswer
                        ? isCorrectAnswer
                           ? '#11A75C'
                           : '#FF3838'
                        : '#808080',
                  },
               ]}>
               <Text
                  style={[
                     styles.answerHeaderText,
                     {
                        fontSize: 24,
                        width: Platform.OS === 'windows' ? '20%' : null,
                     },
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  {answerHeaderTexts}
               </Text>
            </View>
            <View style={styles.answerContainer}>
               <Text
                  style={[
                     styles.answerText,
                     {
                        fontSize: isLandscapeMode ? 20 : 16,
                        color: isSelectedAnswer
                           ? isCorrectAnswer
                              ? '#11A75C'
                              : '#FF3838'
                           : '#FFFFFF',
                        //width: Platform.OS === 'windows' ? '100%' : null,
                     },
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  {answerTexts}
               </Text>
               {answerData?.TestItemAnswerMediaRelativePath && (
                  <Asl
                     url={answerData?.TestItemAnswerMediaRelativePath}
                     showAlsVideo={url => {
                        props.onSignButtonPress(url);
                     }}
                     progressALSVideo={props.progressALSVideo}
                     onMediaClicked={() => {
                        props.onMediaClicked();
                     }}
                     isMediaPlaying={props.isPlaying}
                     isVideoPlaying={props.isMediaPlaying && props.isPlaying}
                     style={{
                        marginTop: isAndroid ? 0 : 5,
                        marginLeft: 3,
                        ...Platform.select({
                           android: {
                              marginLeft: 3,
                              marginTop: 1,
                           },
                           ios: {
                              marginLeft: 3,
                              marginTop: 0,
                           },
                           windows: {
                              marginTop: 0,
                           },
                           macos: {
                              marginTop: 1,
                           },
                        }),
                     }}
                     onMediaFinished={() => {
                        props.onMediaFinished();
                     }}
                     progCircleTintColor="#454545"
                  />
               )}
            </View>
         </View>
      </TouchableOpacity>
   );
};

const styles = StyleSheet.create({
   answerHeaderContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 4,
   },

   answerHeaderText: {
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      fontWeight: '600',
   },
   answerContainer: {
      flex: 0.9,
      flexDirection: 'row',
      paddingLeft: 10,
      paddingRight: 0,
      alignItems: 'center',
   },
   answerText: {
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '500',
      paddingHorizontal: 4,
   },
});

export default ReviewQuestionListItem;
